import { appDomain } from "../AppDomain";
import { EnumUserRole } from "../users/EnumUserRole";
import { IRequestPermission } from "../users/IRequestPermission";

export class PermissionService implements IRequestPermission {
    public permissions: { key: string, roles: EnumUserRole[] }[] =
        [
            {
                key: "attentiondays",
                roles: [EnumUserRole.Administrator]
            }
        ];

    hasSession(): boolean {
        return appDomain.IAuthenticationService.isAuthenticated();
    }

    hasPermission(key: string | null): boolean {
        if (key) {
            const userRole = appDomain.IAuthenticationService.getUserRole();
            const route = this.permissions.filter(x => x.key === key)[0];

            if (route) {
                return route.roles.some(x => x === userRole);
            }
        }
        return this.hasSession();
    }
}
